

import { mapGetters } from 'vuex'

export default {
  name: 'Page',
  computed: {
    ...mapGetters(['infoPages']),
    page () {
      return this.infoPages.find(page => page.url === this.$route.path)
    }
  }
}
